import {
    GeolocateControl
} from 'maplibre-gl';

import {throttle} from '@js/modules/utils';


const Geolocation = (function () {
    const geolocation = {
        mode: 'position', // modes: position, tracking

        positionUpdateThrottling: 300, // 300 ms

        geolocationTimeout: 20000, // 20 seconds
        cacheLocationDuration: 1000, // 1 second
        cacheTrackLocationDuration: 3000, // 3 seconds

        map: null,
        mapId: null,
        isTouchingMap: false,

        onGeolocatingCallback: null,
        onGeolocatedCallback: null,
        onFailedCallback: null,
        onDistanceGeolocatedCallback: null,
        deviceOrientationCallback: null,

        maxZoomOnLocation: 14,

        isLocating: false,
        isLocated: false,
        isTrackingLocation: false,
        isTrackingOrientation: false,
        trackingId: undefined,

        showUserHeading: true,
        showRotateMap: false,
        // showRotateHeading: false,
        rotateMap: false,
        orientationHeading: undefined,
        orientationHeadingOffset: 0
    };

    const _handleGeolocationFailed = function (error) {
        // Manage inconsistent timeout
        if (geolocation.isLocated) {
            return;
        }

        geolocation.isLocated = false;
        geolocation.isLocating = false;
        geolocation.isTrackingLocation = false;

        if ((error.code || error.code === 0) && geolocation.onFailedCallback) {
            geolocation.onFailedCallback(error.code);
        }

        if (typeof geolocation.onGeolocatedCallback === 'function') {
            geolocation.onGeolocatedCallback(geolocation.mode, false);
        }
    };

    // var _updateMapOrientationThrottled = throttle(function (headingAngle) {
    //     if (!geolocation.isTouchingMap) {
    //         geolocation.map.rotateTo(headingAngle, {duration: 50});
    //     }
    // }, geolocation.positionUpdateThrottling * 3);

    const _updateMarkerOrientationThrottled = throttle(function (orientationHeading) {
        const headingElement = document.getElementById('user-location-heading');
        if (!headingElement || !geolocation.map) {
            return;
        }

        const mapAngle = geolocation.map.getBearing() || 0;
        const headingAngle = ((orientationHeading || 0) + geolocation.orientationHeadingOffset) - mapAngle;

        if (geolocation.rotateMap) {
            // _updateMapOrientationThrottled(headingAngle);
            if (!geolocation.isTouchingMap) {
                geolocation.map.rotateTo(orientationHeading, {duration: 50});
            }

            headingElement.style.transform = 'rotate(0deg)';
        } else {
            headingElement.style.transform = 'rotate(' + headingAngle + 'deg)';
        }
    }, geolocation.positionUpdateThrottling);

    const _handleGeolocationSuccess = function (locationEvent) {
        const locationCoordinates = locationEvent.coords;

        // _handleGeolocationSuccess is called twice
        if (geolocation.showUserHeading && !document.getElementById('user-location-heading')) {
            const locationElement = document.getElementsByClassName('maplibregl-user-location-dot')[0];

            if (!locationElement) {
                return;
            }

            locationElement.classList.remove('maplibregl-user-location-dot');

            const dotContainerElement = document.createElement('div');
            dotContainerElement.id = 'user-location-heading';
            dotContainerElement.className = 'maplibregl-user-location-container';
            locationElement.appendChild(dotContainerElement);

            const dotElement = document.createElement('div');
            dotElement.className = 'maplibregl-user-location-dot';
            dotContainerElement.appendChild(dotElement);

            const headingElement = document.createElement('div');
            headingElement.className = 'maplibregl-user-location-heading';
            dotContainerElement.appendChild(headingElement);
        }

        if (geolocation.mode === 'position') {
            geolocation.isLocating = false;
        }

        geolocation.isLocated = true;

        geolocation.onGeolocatedCallback(geolocation.mode, {
            latitude: locationCoordinates.latitude,
            longitude: locationCoordinates.longitude,
            altitude: locationCoordinates.altitude
        });
    };

    const _handleOrientationSuccess = function (deviceOrientationEvent) {
        // absolute is true if the orientation data is provided as the difference between the Earth's coordinate frame and the device's coordinate frame, or false if the orientation data is being provided in reference to some arbitrary, device-determined coordinate frame.
        if (deviceOrientationEvent.webkitCompassHeading) {
            // Safari
            geolocation.orientationHeading = deviceOrientationEvent.webkitCompassHeading;
        } else if (deviceOrientationEvent.absolute === true) {
            // Non-Safari alpha increases counter clockwise around the z axis
            geolocation.orientationHeading = deviceOrientationEvent.alpha * -1;

            // // Chrome has an offset of 180°
            // if (window.chrome) {
            //     geolocation.orientationHeading -= 180;
            // }
        }

        _updateMarkerOrientationThrottled(geolocation.orientationHeading);
    };

    geolocation.buildGeolocator = function (geolocationParams) {
        geolocation.mapId = geolocationParams.mapId;

        if (geolocationParams.onGeolocating) {
            geolocation.onGeolocatingCallback = geolocationParams.onGeolocating;
        }

        if (geolocationParams.showRotateMap) {
            geolocation.showRotateMap = geolocationParams.showRotateMap;
        }

        const control = new GeolocateControl({
            positionOptions: {
                // Enables high accuracy
                enableHighAccuracy: true,
                // Number of milliseconds to wait for a response from geolocation before firing a locationerror event.
                timeout: geolocation.geolocationTimeout,
                // Maximum age of detected location. If less than this amount of milliseconds passed since last geolocation response, locate will return a cached location.
                maximumAge: !!geolocationParams.track ? geolocation.cacheTrackLocationDuration : geolocation.cacheLocationDuration,
            },
            fitBoundsOptions: {
                animate: true,
                maxZoom: geolocationParams.maxZoom || geolocation.maxZoomOnLocation
            },
            // When active the map will receive updates to the device's location as it changes.
            trackUserLocation: geolocationParams.track,
            // Draw an arrow next to the location dot to indicate which direction the device is heading.
            showUserHeading: geolocation.showUserHeading,
            // Disable circle around point (circle drawn around the user location indicating the accuracy (95% confidence level) of the user's location)
            showAccuracyCircle: false
        });

        // Following: frame the accuracy until the first framing has landed, then keep the zoom the user chose
        if (geolocationParams.track) {
            let framing = false;
            let awaitingLanding = false;

            const keepUserZoom = () => {
                framing = false;
                control.options.zoomToUserAccuracy = false;
            };

            // A new flight first stops the running one, which also fires moveend: check on the next tick
            const keepUserZoomOnceLanded = () => {
                const map = control._map;
                if (!map || awaitingLanding) {
                    return;
                }

                awaitingLanding = true;
                map.once('moveend', () => {
                    setTimeout(() => {
                        awaitingLanding = false;
                        if (!framing) {
                            return;
                        }
                        if (map.isMoving()) {
                            keepUserZoomOnceLanded();
                        } else {
                            keepUserZoom();
                        }
                    }, 0);
                });
            };

            control.on('trackuserlocationstart', () => {
                framing = true;
                control.options.zoomToUserAccuracy = true;
            });
            control.on('geolocate', () => {
                if (framing) {
                    keepUserZoomOnceLanded();
                }
            });
            // Re-centring a follow the user panned away from (fired after trackuserlocationstart)
            control.on('userlocationfocus', keepUserZoom);
        }

        return control;
    };

    geolocation.buildButtons = function (params) {
        const topRightControls = document.getElementsByClassName('maplibregl-ctrl-top-right')[0];
        if (!topRightControls) {
            return;
        }

        geolocation.map = params.map;

        /** Watch touch map state **/
        geolocation.map.on('touchstart', function () {
            geolocation.isTouchingMap = true;
        });
        geolocation.map.on('touchend', function () {
            geolocation.isTouchingMap = false;
        });
        geolocation.map.on('touchcancel', function () {
            geolocation.isTouchingMap = false;
        });

        // The map may already be gone when this runs (it is called back after the map load event)
        const mapContainer = geolocation.map.getContainer ? geolocation.map.getContainer() : document.getElementById(geolocation.mapId);
        if (!mapContainer) {
            return;
        }

        mapContainer.addEventListener('click', (event) => {
            if (!event.target || !event.target.parentElement) {
                return;
            }

            if (event.target.matches('.maplibregl-ctrl-geolocate') || event.target.parentElement.matches('.maplibregl-ctrl-geolocate')) {
                if (typeof geolocation.onGeolocatingCallback === 'function') {
                    geolocation.onGeolocatingCallback();
                }
            }
        });

        /** Rotate map **/
        if (geolocation.showRotateMap) {
            const followDirectionContainer = document.createElement('div');
            followDirectionContainer.className = 'maplibregl-ctrl maplibregl-ctrl-group';

            const followDirection = document.createElement('button');
            followDirection.className = 'maplibregl-ctrl-geolocate-rotate';
            followDirectionContainer.appendChild(followDirection);

            const followDirectionIcon = document.createElement('span');
            followDirectionIcon.className = 'maplibregl-ctrl-follow-direction';
            followDirectionIcon.style.transform = 'rotateZ(220deg)';
            followDirection.appendChild(followDirectionIcon);

            topRightControls.appendChild(followDirectionContainer);

            followDirection.onclick = function (event) {
                event.preventDefault();

                geolocation.rotateMap = !geolocation.rotateMap;

                if (geolocation.rotateMap) {
                    followDirectionIcon.style.color = '#1da1f2';
                } else {
                    followDirectionIcon.style.color = '#000';
                }
            };
        }

        // /** Rotate heading **/
        // if (geolocation.showRotateHeading) {
        //     var rotateHeadingButtonContainer = document.createElement('div');
        //     rotateHeadingButtonContainer.className = 'maplibregl-ctrl maplibregl-ctrl-group';
        //
        //     var rotateHeadingButton = document.createElement('button');
        //     rotateHeadingButton.className = 'maplibregl-ctrl-geolocate';
        //     rotateHeadingButtonContainer.appendChild(rotateHeadingButton);
        //
        //     var rotateHeadingButtonIcon = document.createElement('span');
        //     rotateHeadingButtonIcon.className = 'material-icons';
        //     rotateHeadingButtonIcon.style.fontSize = '20px';
        //     rotateHeadingButtonIcon.style.lineHeight = '30px';
        //     rotateHeadingButtonIcon.setAttribute('data-icon', 'replay');
        //     rotateHeadingButtonIcon.setAttribute('aria-hidden', 'true');
        //     rotateHeadingButton.appendChild(rotateHeadingButtonIcon);
        //
        //     topRightControls.appendChild(rotateHeadingButtonContainer);
        //
        //     rotateHeadingButton.onclick = function (event) {
        //         event.preventDefault();
        //
        //         geolocation.orientationHeadingOffset += 45;
        //         _updateMarkerOrientationThrottled(geolocation.orientationHeading);
        //     };
        // }
    };

    // call a callback with two parameters: current mode and position ({latitude, longitude, altitude})
    geolocation.geolocate = function (geolocationParams, geolocatedCallback, failedCallback) {
        if (geolocation.isLocating || geolocation.isTrackingLocation) {
            return;
        }

        if (typeof failedCallback === 'function') {
            geolocation.onFailedCallback = failedCallback;
        }

        geolocation.isLocated = false;
        if (typeof geolocationParams.showUserHeading !== 'undefined') {
            geolocation.showUserHeading = geolocationParams.showUserHeading;
        }

        const previousMode = geolocation.mode;
        if (geolocationParams.track) {
            geolocation.mode = 'tracking';
            geolocation.isTrackingLocation = true;
        } else {
            geolocation.isLocating = true;
        }

        if (!!window.navigator.geolocation) {
            // Support
            if (typeof geolocatedCallback === 'function') {
                geolocation.onGeolocatedCallback = geolocatedCallback;
            }

            // Track user geolocation
            if (!!geolocationParams.geolocator) {
                if (geolocationParams.geolocator.trigger() === false) {
                    geolocation.mode = previousMode;
                    geolocation.isLocating = false;
                    geolocation.isTrackingLocation = false;
                    return;
                }

                // Set an event listener that fires when a geolocate event occurs.
                geolocationParams.geolocator.on('geolocate', _handleGeolocationSuccess);
                geolocationParams.geolocator.on('error', _handleGeolocationFailed);
            } else if (geolocationParams.useNavigator) {
                // Use browser geolocation
                geolocation.trackingId = window.navigator.geolocation.watchPosition(_handleGeolocationSuccess);
            } else {
                window.navigator.geolocation.getCurrentPosition(
                    _handleGeolocationSuccess,
                    _handleGeolocationFailed,
                    {
                        enableHighAccuracy: true,
                        timeout: geolocation.geolocationTimeout,
                        maximumAge: geolocation.cacheLocationDuration
                    }
                );
            }

            // Track device orientation
            geolocation.deviceOrientation();
        } else {
            // No support

            geolocation.isLocated = false;
            geolocation.isLocating = false;

            _handleGeolocationFailed({code: 4});
        }
    };

    // stop tracking user geolocation
    geolocation.stopGeolocating = function (geolocationParams) {
        if (!!geolocationParams.geolocator) {
            geolocationParams.geolocator._clearWatch();
            geolocationParams.geolocator._finish();
        } else if (geolocation.trackingId) {
            window.navigator.geolocation.clearWatch(geolocation.trackingId);
        }

        window.removeEventListener('deviceorientation', _handleOrientationSuccess);
        window.removeEventListener('deviceorientationabsolute', _handleOrientationSuccess);

        geolocation.isTrackingLocation = false;
    };

    // return device orientation angle to north
    geolocation.deviceOrientation = function (deviceOrientationCallback) {
        if (geolocation.isTrackingOrientation || !geolocation.showUserHeading) {
            return;
        }

        if (!!window.DeviceOrientationEvent) {
            // Support
            if (typeof deviceOrientationCallback === 'function') {
                geolocation.deviceOrientationCallback = deviceOrientationCallback;
            }

            geolocation.isTrackingOrientation = true;

            const addOrientationListener = function () {
                if ('ondeviceorientationabsolute' in window) {
                    window.addEventListener('deviceorientationabsolute', _handleOrientationSuccess);
                } else {
                    window.addEventListener('deviceorientation', _handleOrientationSuccess);
                }
            };

            if (typeof window.DeviceMotionEvent !== 'undefined' &&
                typeof window.DeviceMotionEvent.requestPermission === 'function') {
                DeviceOrientationEvent.requestPermission()
                    .then(function (response) {
                        if (response === 'granted') {
                            addOrientationListener();
                        }
                    })
                    .catch(console.error);
            } else {
                addOrientationListener();
            }

            // window.addEventListener('deviceorientation', throttle(function (event) {
            //     // const absolute = event.absolute;
            //     // // var alpha = event.alpha; // z-axis: 0 to 360 degrees; 0 is the north
            //     // const beta = event.beta; // x-axis: -180 to 180 degrees; 0 is parallel to earth
            //     // const gamma = event.gamma; // y-axis: -90 to 90 degrees; 0 is parallel to earth
            //
            //     let alpha;
            //     let rotation;
            //     if (!!event.webkitCompassHeading) {
            //         //Rotation is reversed for iOS
            //         alpha = event.webkitCompassHeading;
            //         rotation = alpha;
            //     } else {
            //         //non iOS
            //         alpha = event.alpha + 180;
            //         rotation = -alpha;
            //         if (!window.chrome) {
            //             rotation = alpha - 270;
            //         }
            //     }
            //
            //     geolocation.deviceOrientationCallback(rotation);
            // }, 50), true);
        } else {
            // No support
            console.error('The browser doesn\'t support Device Orientation');
        }
    };

    // call a callback with one parameter: distance (meters)
    // geolocation.distanceFromGeolocation = function (coordinates, onDistanceGeolocatedCallback) {
    //     if (typeof (onDistanceGeolocatedCallback) === 'function') {
    //         geolocation.onDistanceGeolocatedCallback = onDistanceGeolocatedCallback;
    //     }
    //
    //     geolocate(function (mode, positionLocated) {
    //         if (positionLocated) {
    //             const distance = Math.floor(MapInterface.distHaversine(
    //                 {
    //                     lat: positionLocated.latitude,
    //                     lng: positionLocated.longitude
    //                 },
    //                 {
    //                     lat: coordinates.latitude,
    //                     lng: coordinates.longitude
    //                 }
    //             ));
    //
    //             geolocation.onDistanceGeolocatedCallback(distance);
    //         }
    //     });
    // }

    return geolocation;
})();

export default Geolocation;
